<template>
    <div id="app">
        <!-- Header -->
        <div class="columns is-vcentered">
            <div class="column is-half">
                <h1 class="title is-4">👷 SINAPI.APP - Consulte as tabelas SINAPI facilmente</h1>
                <p class="subtitle is-5">
                    Aplicativo web gratuíto mantido pela <a target="_blank" href="https://fibersals.com.br">Fibersals</a> 
                    para auxiliar profissionais da área. Somos especialistas em <strong>impermeabilização
                    sem remoção do piso com 15 anos de garantia.</strong>
                </p>
                <p>
                    <strong class="has-text-danger">Problemas?</strong>
                    Favor reportar para <a href="mailto:sinapi.app@fibersals.com.br">sinapi.app@fibersals.com.br</a>
                </p>
            </div>
            <div class="column is-half">
                <p>
                    Os dados de origem são as tabelas SINAPI obtidas no site da Caixa Economica Federal <a target="_blank" href="https://www.caixa.gov.br/poder-publico/apoio-poder-publico/sinapi/referencias-precos-insumos/Paginas/default.aspx">neste link</a>.
                    As tabelas são processadas pelo SINAPI.APP e transformadas em um conjunto de dados que pode ser consultado facilmente.
                </p>
                <p>Última atualização publicada pela Caixa: Setembro de 2022</p>
                <p class="has-text-danger">Não nos responsabilizamos pela forma como os dados são usados.</p>
            </div>
        </div>
        <hr />
        <div v-if="!loading">
            <div class="columns -vcentered">
                <!-- Select UF -->
                <div class="column">
                    <div class="field">
                        <label class="label">Escolha uma UF</label>
                        <div class="select">
                            <select v-model="selectedUf">
                                <option value="" selected>Escolha uma UF</option>
                                <option :value="uf.toLowerCase()" v-for="uf in ufs" :key="uf">
                                    {{ uf }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <!-- Select TIPO -->
                <div class="column">
                    <div class="field" v-show="list">
                        <label class="label">Escolha um tipo de custo (opcional)</label>
                        <div class="select">
                            <select v-model="selectedTipo">
                                <option value="" selected>Insumos e composições</option>
                                <option value="insumo">Insumos</option>
                                <option value="composicao">Composições</option>
                            </select>
                        </div>
                    </div>
                </div>
                <!-- Search box -->
                <div class="column">
                    <div class="field" v-show="list">
                        <label class="label">Pesquisar (descrição ou código)</label>
                        <input class="input" type="" name="" v-model="searchString" v-on:keyup.enter="search">
                    </div>
                </div>
            </div>
            <div class="list" v-if="displayedList">
                <table class="table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Tipo</th>
                            <th>Descrição</th>
                            <th>Unidade</th>
                            <th>Desonerado</th>
                            <th>Não desonerado</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in displayedList.slice(0, this.limit)" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ row.tipo }}</td>
                            <td v-html="row.descricao" />
                            <td>{{ row.unidade }}</td>
                            <td>R$ {{ row.precos.desonerado }}</td>
                            <td>R$ {{ row.precos.naoDesonerado }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <template v-else>
            ⌛ Carregando
        </template>
    </div>
</template>

<script>
const axios         = require('axios')
const _             = require('underscore')
var lunr            = require('lunr')
require("lunr-languages/lunr.stemmer.support")(lunr)
require("lunr-languages/lunr.pt")(lunr)

export default {
name: 'App',
    components: {
    },
    data: function() {
        return {
            ufs: [
                'AC',  'AL',  'AP',  'AM',  'BA',  'CE',  'DF',  'ES',  'GO',  
                'MA',  'MT',  'MS',  'MG',  'PA',  'PB',  'PR',  'PE',  'PI', 
                'RJ',  'RN',  'RS',  'RO',  'RR',  'SC',  'SP',  'SE',  'TO'
            ],
            selectedUf:     null,
            selectedTipo:   null,
            loading:        false,
            list:           null,
            displayedList:  null,
            searchString:   null,
            limit:          100,
            idx:            null
        }
    },
    watch: {
        selectedUf() {
            this.searchString = null
            this.selectedTipo = null
            this.refresh()
        },
        selectedTipo(val) {
            this.searchString = null
            this.lock() // This is not being triggered
            if (val) {
                this.displayedList = _.where(this.list, { tipo: val })
            } else {
                this.displayedList = this.list
            }
            this.buildIndex(this.displayedList)
            this.unlock() // This is not being triggered
        }
    },
    methods: {
        buildIndex(data) {
            this.idx = lunr(function () {
                this.field('descricao')
                this.field('codigo')
                this.ref('id')
                data.forEach((entry) => {
                   this.add({
                        id:         entry.id,
                        codigo:     entry.id,
                        descricao:  entry.descricao
                    })
                })
            })
        },
        refresh() {
            this.lock()
            axios.get(`./ufs/${this.selectedUf.toLowerCase()}.json`).then((response) => {
                this.list = response.data
                this.displayedList = response.data
                this.buildIndex(response.data)
                this.unlock()
            }).catch((err) => {
                console.log(err)
                this.unlock()
            })
        },
        search() {
            //Empty string and hit enter
            //reset results
            if (!this.searchString) {
                this.displayedList = this.list
                return
            }
            let results = this.idx.search(this.searchString)
            let newList = []
            _.forEach(results, (entry, index) => {
                if (index >= this.limit)
                    return
                let record = _.find(this.list, { id: entry.ref })
                _.each(entry.matchData.metadata, (field, highlightedWord) => {
                    record.descricao = record.descricao.replace(highlightedWord.toUpperCase(), `<mark>${ highlightedWord.toUpperCase() }</mark>`)
                })
                newList.push(record)
            })
            this.displayedList = newList
        },
        lock() {
            this.loading = true
        },
        unlock() {
            this.loading = false
        }
    }
}
</script>

<style>

</style>
